import { render, staticRenderFns } from "./AuthorizeTab1.vue?vue&type=template&id=129c33f1"
import script from "./AuthorizeTab1.vue?vue&type=script&lang=js"
export * from "./AuthorizeTab1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports